<template>
  <div class="add-basic-information" style="overflow:auto">
    <div class="add-title">
      <span class="bold add-bold"></span>
      <span class="basic" style="padding-left:26px">工单日志</span>
    </div>
    <div class="block infinite-list-wrapper operation" style="overflow:auto">
      <!-- <el-tabs v-model="activeNameTabs" type="card" @tab-click="handleClick"> -->
      <!-- <el-tab-pane label="工单日志" name="workOperationLog"> -->
      <el-timeline v-infinite-scroll="load" infinite-scroll-disabled="disabled">
        <el-timeline-item
          class="infinite-list-item"
          v-for="(activity, index) in list"
          :key="index"
          :type="activity.type"
          :color="activity.color"
          :size="activity.size"
        >
          <span style="padding-left:30px">{{activity.createDate|dateFilter}}</span>
          <span style="padding-left:30px;">
            <el-tooltip
              :disabled="activity.createUser.length < 4"
              class="item"
              effect="dark"
              :content="activity.createUser"
              placement="top-start"
            >
              <div
                style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;min-width: 80px;width: 80px;"
              >{{activity.createUser}}</div>
            </el-tooltip>
          </span>
          <span style="padding-left:30px">{{activity.optContent}}</span>
        </el-timeline-item>
        <p v-if="loading">加载中......</p>
        <p v-if="noMore">没有更多了</p>
      </el-timeline>
      <!-- </el-tab-pane> -->
      <!-- <el-tab-pane :label="flowLabel" name="signFlow">
              流程暂时不画
      </el-tab-pane>-->
      <!-- </el-tabs> -->
    </div>
  </div>
</template>

<script>
import {
  queryPageAllBySuaId
} from '@/api/system/rightsManagement'
import { formatDate } from '@/util/tool'
export default {
  props: ['flowLabel', 'id', 'typesel'],
  data () {
    return {
      total: 0,
      currentPage: 0, // 当前页
      pageSize: 10, // 分页页数
      list: [],
      loading: false,
      noMore: false,
      activeNameTabs: 'workOperationLog'
    }
  },
  computed: {
    disabled () {
      return this.loading || this.noMore
    }
  },
  watch: {
    id: {
      handler () {
        this.currentPage = 1
        this.onInitial(this.id)
      },
      deep: true
    }
  },
  methods: {
    // 页面初始化
    onInitial (id) {
      if (this.$route.path === '/sell/personageManagement/contractCreate') {
        this.getList('orderContractBase', id)
      } else if (
        this.$route.path === '/purchase/purchaseManage/createContract'
      ) {
        this.getList('purchaseContractBase', id)
      } else if (
        this.$route.path === '/purchase/purchaseManage/shipmentDetails'
      ) {
        this.getList('purchaseContractDeliverBase', id)
      } else if (
        this.$route.path === '/purchase/purchaseManage/ticketCollectionDetails'
      ) {
        this.getList('purchaseInvoice', id)
      } else if (
        this.$route.path === '/purchase/purchaseManage/refundDetails'
      ) {
        this.getList('purchaseInvoiceSub', id)
      } else if (this.$route.path === '/sell/personageManagement/stockUpEdit') {
        // 备货详情单
        this.getList('orderAddContractStockup', id)
      } else if (this.$route.path === '/finance/financeManage/dealList') {
        this.getList('finaceBankReceipt', id)
      } else if (this.$route.path === '/finance/financeManage/CollectionList') {
        this.getList('finaceBankReceipt', id)
      } else if (this.$route.path === '/finance/financeManage/passList') {
        this.getList('finaceBankReceipt', id)
      } else if (this.$route.path === '/purchase/purchaseManage/paymentDetails') {
        this.getList('supplierContractPay', id)
      } else if (this.$route.path === '/purchase/purchaseManage/supplierPayDetial') {
        this.getList('supplierRecharge', id)
      } else {
        this.getList(this.typesel, id)
      }
    },
    // 初始化方法工单日志带id(如果不需要带id和不需要流程功能的话,换另一个组件叫loadOperationLog)
    getList (type, id) {
      queryPageAllBySuaId(type, id, this.currentPage, this.pageSize)
        .then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 加载更多
    load () {
      this.loading = true
      setTimeout(() => {
        if (this.$route.path === '/sell/personageManagement/contractCreate') {
          // 合同详情
          this.getAllOperationLoad('orderContractBase', this.id)
        } else if (
          this.$route.path === '/purchase/purchaseManage/createContract'
        ) {
          this.getAllOperationLoad('purchaseContractBase', this.id)
        } else if (
          this.$route.path === '/purchase/purchaseManage/shipmentDetails'
        ) {
          this.getAllOperationLoad('purchaseContractDeliverBase', this.id)
        } else if (
          this.$route.path ===
          '/purchase/purchaseManage/ticketCollectionDetails'
        ) {
          this.getAllOperationLoad('purchaseInvoice', this.id)
        } else if (
          this.$route.path === '/purchase/purchaseManage/refundDetails'
        ) {
          this.getAllOperationLoad('purchaseInvoiceSub', this.id)
        } else if (
          this.$route.path === '/sell/personageManagement/stockUpEdit'
        ) {
          // 备货详情单
          this.getAllOperationLoad('orderAddContractStockup', this.id)
        } else if (this.$route.path === '/finance/financeManage/dealList') {
          this.getAllOperationLoad('finaceBankReceipt', this.id)
        } else if (
          this.$route.path === '/finance/financeManage/CollectionList'
        ) {
          this.getAllOperationLoad('finaceBankReceipt', this.id)
        } else if (this.$route.path === '/finance/financeManage/passList') {
          this.getAllOperationLoad('finaceBankReceipt', this.id)
        } else if (this.$route.path === '/purchase/purchaseManage/paymentDetails') {
          this.getAllOperationLoad('supplierContractPay', this.id)
        } else if (this.$route.path === '/purchase/purchaseManage/supplierPayDetial') {
          this.getAllOperationLoad('supplierRecharge', this.id)
        } else {
          this.getAllOperationLoad(this.typesel, this.id)
        }
      }, 2000)
    },
    // 滚动加载更多
    getAllOperationLoad (type, id) {
      queryPageAllBySuaId(
        type,
        id,
        (this.currentPage += 1),
        this.pageSize
      ).then((res) => {
        if (res.data.code === 200) {
          const arrList = res.data.obj.records
          if (res.data.obj.records.length < 10) {
            this.noMore = true
          }
          this.list = this.list.concat(arrList)
          this.loading = false
        }
      })
    },
    // 切换tabs
    handleClick () { }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  const date = new Date(time)
  // eslint-disable-next-line no-undef
  return formatDate(date, 'yyyy-MM-dd hh:mm')
}
</script>

<style lang="scss" scoped>
.block {
  padding: 10px 0 0 20px;
}
.infinite-list-item {
  font-size: 0;
  span {
    font-size: 14px;
    vertical-align: middle;
  }
}
</style>
